import React from 'react';
import './Dropdown.scss';

interface Props {
  names: string[];
  placeholder: string;
  onChange: (string) => void;
  values: string[];
}

export default function Dropdown({
  names = [],
  placeholder = '',
  onChange = () => {},
  values = [],
}: Props) {
  return (
    <div className="dropdown-deviation">
      <div className="dropdown-button">{placeholder}</div>
      <div className="dropdown-content">
        {names &&
          names.map((name, i) => (
            <div
              key={name}
              className="dropdown-content-button"
              onClick={() => onChange(values.length !== 0 ? values[i] : name)}
            >
              {name}
            </div>
          ))}
      </div>
    </div>
  );
}
